export const center = `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const svgElementsFillCurrentColor = `
  circle,
  ellipse,
  line,
  path,
  polygon,
  polyline,
  rect {
    fill: currentColor !important;
  }
`;
